import { Alert, CircularProgress, Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import { useCase } from "../api/useCase";
import { useVisit } from "../api/useVisit";
import { MobileEditVisitForm } from "./MobileEditVisitForm";

export function MobileEditVisitContainer() {
  const { caseId, visitId } = useParams<{ caseId: string; visitId: string }>();
  const { data: visit, isLoading, isError } = useVisit(visitId);
  const { data: caseItem } = useCase(caseId);

  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: "40vh" }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (isError || !visit) {
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        Error loading visit.
      </Alert>
    );
  }

  return (
    <MobileEditVisitForm
      visit={visit}
      patientAddress={caseItem?.attributes.patient.attributes.formattedAddress ?? ""}
    />
  );
}
